import { defineMessages } from 'react-intl';

export const customerRatingsMessages = defineMessages({
  headline: {
    id: 'detailview.grid.headline.ratings',
    defaultMessage: 'Kundenbewertungen',
  },
  title: { id: 'ratingsOverview.title', defaultMessage: 'Bewertungsübersicht' },
});
